import { BehaviorSubject, map, Observable } from 'rxjs';

export class LoaderController {
  private readonly counter = new BehaviorSubject<number>(0);
  public readonly isLoading$: Observable<boolean>;

  constructor() {
    this.isLoading$ = this.counter.pipe(map((amount) => amount > 0));
  }

  enqueue(): void {
    const currentValue = this.counter.getValue();
    this.counter.next(currentValue + 1);
  }

  dequeue(): void {
    const currentValue = this.counter.getValue();
    const nextValue = currentValue > 0 ? currentValue - 1 : 0;
    this.counter.next(nextValue);
  }

  isLoadingNow(): boolean {
    return this.counter.getValue() !== 0;
  }
}
